import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const seekerJobTitleSlice = createSlice({
  name: "seekerJobTitle",
  initialState,
  reducers: {
    setSeekerJobTitle: (state, action) => {
      return [...action.payload];
    },
  },
});

export const { setSeekerJobTitle } = seekerJobTitleSlice.actions;
export default seekerJobTitleSlice.reducer;
